import { PickerCategoryType } from "components/CC/UI/ParameterPicker/buildParameterPickerCategories";

export type TagInputModePolicy = "free" | "strict-single" | "tag-only";

export interface StepInputPolicy {
    ui: {
        mode?: TagInputModePolicy;
        allowedCategories: PickerCategoryType[];
    };
    /**
     * Current BE mapping contract.
     * - static text: "text"
     * - form field: "{data_<system_name>}"
     * - tracking/system param: "{external_id}" (no data_ prefix)
     * - previous/custom key: "{my_key}"
     * - modify row: "{_1}"
     */
    beMapping: string;
}

const DYNAMIC_DEFAULT: StepInputPolicy = {
    ui: {
        mode: "free",
        allowedCategories: ["form_fields", "keys", "system", "steps", "functions"],
    },
    beMapping: `text | {data_<system_name>} | {<tracking_param>} | {<previous_or_custom_key>}`,
};

export const STEP_INPUT_POLICIES = {
    http: {
        endpoint: DYNAMIC_DEFAULT,
        headerKey: DYNAMIC_DEFAULT,
        headerValue: DYNAMIC_DEFAULT,
        queryKey: DYNAMIC_DEFAULT,
        queryValue: DYNAMIC_DEFAULT,
        bodyKey: DYNAMIC_DEFAULT,
        bodyValue: DYNAMIC_DEFAULT,
    },
    set: {
        key: {
            ui: {
                mode: "tag-only",
                allowedCategories: ["form_fields", "keys", "system"],
            },
            beMapping: `plain tag name without braces — e.g. "myVar" (not "{myVar}")`,
        } satisfies StepInputPolicy,
        value: DYNAMIC_DEFAULT,
    },
    modify: {
        target: {
            ui: {
                mode: "tag-only",
                allowedCategories: ["form_fields", "keys", "system"],
            },
            beMapping: `plain tag name without braces — e.g. "myVar" (not "{myVar}")`,
        } satisfies StepInputPolicy,
        source: {
            ui: {
                mode: "free",
                allowedCategories: ["form_fields", "keys", "system", "steps", "rows", "functions"],
            },
            beMapping: `text | {data_<system_name>} | {<tracking_param>} | {<previous_or_custom_key>} | {_<row_number>}`,
        } satisfies StepInputPolicy,
        filterParams: DYNAMIC_DEFAULT,
        changeParams: DYNAMIC_DEFAULT,
    },
    webhook: {
        token: DYNAMIC_DEFAULT,
    },
    condition: {
        value: DYNAMIC_DEFAULT,
        output: DYNAMIC_DEFAULT,
    },
    breaker: {
        maxRepetition: {
            ui: {
                mode: "free",
                allowedCategories: ["form_fields", "keys", "system", "steps"],
            },
            beMapping: DYNAMIC_DEFAULT.beMapping,
        } satisfies StepInputPolicy,
    },
} as const;
